import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import styles from './GDPRFAQ.module.css';

import Container from '../../../blocks/Container';

const GDPRFAQ = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/gdpr.md/" } }) {
        edges {
          node {
            html
          }
        }
      }
    }
  `);

  const { html } = data.allMarkdownRemark.edges[0].node;

  return (
    <div className={styles.gdprFaq}>
      <Container type="big">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Container>
    </div>
  )
};

export default GDPRFAQ;